import React, {Component} from 'react';


import Pages from '../Pages/Pages';
import Footer from '../Footer/Footer';
import axios from 'axios';
import { withRouter } from 'react-router';


class PagesContainer extends Component {
  
  state ={pages:[]}

  componentDidMount(){
    
    const { match } = this.props;
   const pageId=match.params.pageId;
   console.log("pageId" +pageId);

    axios.get('https://api.shopmuthu.com/page/'+pageId)
    .then( response => {

      console.log(response);
      this.setState({pages:response.data});
      
    });
  }

  render (){

    let pageContent=null;
    
    //console.log(this.state.products.specification); 
    pageContent= (
          
          <div>   
          
            {this.state.pages.map( (page,index) =>{                   
                            
            return  <Pages 
              click={() => this.showProductDisplayPage(index)}
              key = {page.pageName}    
              page={page}     
                          
                 
            />
            
          
            })}
            
          </div>
         );      
   
    

    return (
      <React.Fragment>
        
       
            {pageContent}
       
           <Footer/>
            </React.Fragment>
    );
    }
  }

export default withRouter(PagesContainer);
